import React from 'react';
import { EnumMediaType } from '../index';
import { mediaModalData } from '../../../../../Data';
import MediaItem from './Item';
import FakePagination from '../../../../../../../../../../components/Common/UI/FakePagination';

function ModalMediaList({ type }: { type: EnumMediaType }) {
  return (
    <div>
      <div className="grid grid-cols-[repeat(4,150px)] gap-[15px] mb-[10px]">
        {mediaModalData.map(el => (
          <MediaItem data={el} key={el.id} type={type} />
        ))}
      </div>
      <FakePagination value="1 - 15 of 104" />
    </div>
  );
}

export default ModalMediaList;
